module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/LChevron1.2867b0e2.svg";